import { PortalRoutePath } from "@/microfrontends/portalRoutePaths";

export const PORTAL_NAV_MESSAGE = "compliance-portal-navigate";
export const PORTAL_AUTH_MESSAGE = "compliance-portal-auth";
export const PORTAL_LOGOUT_MESSAGE = "compliance-portal-logout";

// const DEFAULT_PORTAL_PREVIEW_ORIGIN = "http://127.0.0.1:4174";
const DEFAULT_PORTAL_PREVIEW_ORIGIN = "https://dev-portal.nationbetter.uk";

export function portalPreviewOrigin(): string {
  const fromEnv = process.env.VUE_APP_PORTAL_PREVIEW_ORIGIN;
  if (fromEnv && fromEnv.length > 0) {
    return fromEnv.trim().replace(/\/$/, "");
  }
  return DEFAULT_PORTAL_PREVIEW_ORIGIN;
}

export function portalIframeSrc(portalPath: PortalRoutePath): string {
  const segment = portalPath.startsWith("/") ? portalPath : `/${portalPath}`;
  return `${portalPreviewOrigin()}${segment}?embed=shell`;
}

export function postPortalNavigate(iframe: HTMLIFrameElement, portalPath: PortalRoutePath): void {
  if (!iframe.contentWindow) return;

  let targetOrigin = portalPreviewOrigin();
  try {
    targetOrigin = new URL(iframe.src).origin;
  } catch {
    // keep configured portal origin
  }

  iframe.contentWindow.postMessage({ type: PORTAL_NAV_MESSAGE, portalPath }, targetOrigin);
}
